import React from "react";
import { statusOf } from "@/lib/format";

export function Panel({ title, subtitle, right, children, className = "", testid }) {
  return (
    <section
      data-testid={testid}
      className={`bg-white border border-slate-200 rounded-md shadow-sm ${className}`}
    >
      {(title || right) && (
        <header className="flex items-center justify-between px-4 lg:px-5 py-3 border-b border-slate-100">
          <div>
            {title && <h3 className="text-sm font-semibold text-slate-900 tracking-tight">{title}</h3>}
            {subtitle && <p className="text-xs text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {right}
        </header>
      )}
      <div className="p-4 lg:p-5">{children}</div>
    </section>
  );
}

export function StatusBadge({ status, children, testid }) {
  const s = statusOf(status);
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-[11px] font-semibold ${s.bg} ${s.text}`}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: s.color }} />
      {children || status}
    </span>
  );
}

export function Kpi({ label, value, unit, sub, accent, onClick, testid }) {
  return (
    <button
      data-testid={testid}
      onClick={onClick}
      className={`text-left w-full ${onClick ? "cursor-pointer hover:border-slate-300 hover:shadow-md" : "cursor-default"} bg-white border border-slate-200 rounded-md p-4 transition-all duration-200`}
    >
      <div className="text-[11px] font-semibold tracking-[0.06em] uppercase text-slate-500">{label}</div>
      <div className="mt-1.5 flex items-baseline gap-1">
        <span className="text-2xl lg:text-[28px] font-bold font-mono tracking-tight text-slate-900" style={accent ? { color: accent } : {}}>
          {value}
        </span>
        {unit && <span className="text-xs font-medium text-slate-500">{unit}</span>}
      </div>
      {sub && <div className="text-xs text-slate-500 mt-1">{sub}</div>}
    </button>
  );
}

export function Loading({ label = "Loading live data…" }) {
  return (
    <div className="flex items-center gap-2 text-sm text-slate-400 py-10 justify-center">
      <span className="w-2 h-2 rounded-full bg-emerald-500 live-dot" />
      {label}
    </div>
  );
}

export function PageHeader({ title, subtitle, icon: Icon, right }) {
  return (
    <div className="flex items-start justify-between mb-5">
      <div className="flex items-start gap-3">
        {Icon && (
          <div className="w-10 h-10 rounded-md bg-slate-900 text-white flex items-center justify-center shrink-0">
            <Icon size={20} />
          </div>
        )}
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
          {subtitle && <p className="text-sm text-slate-500 mt-0.5">{subtitle}</p>}
        </div>
      </div>
      {right}
    </div>
  );
}

export function DataRow({ label, value, mono = true }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-slate-100 last:border-0">
      <span className="text-sm text-slate-600">{label}</span>
      <span className={`text-sm ${mono ? "font-mono" : ""} font-medium text-slate-900`}>{value}</span>
    </div>
  );
}
